import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useUtility, Stack, shape, Text } from '@hub-la/design-system';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { Wrapper, IconContainer } from './time-to-release-card.styled.js';

const TimeToReleaseCard = ({
  timeToRelease
}) => {
  const {
    t
  } = useTranslation();
  const {
    palette
  } = useUtility();
  return jsx(Wrapper, Object.assign({
    direction: ['column', 'row'],
    "data-testid": "time-to-release-card"
  }, {
    children: jsxs(Stack, Object.assign({
      direction: "row",
      spacing: 4,
      alignItems: "center",
      flex: 1
    }, {
      children: [jsx(IconContainer, Object.assign({
        borderRadius: shape('small'),
        overflow: "hidden"
      }, {
        children: jsx(LockOutlinedIcon, {
          style: {
            color: palette('outline')
          }
        })
      })), jsxs(Stack, Object.assign({
        direction: "column"
      }, {
        children: [jsx(Text, {
          children: jsx("b", {
            children: t('postDetail.releaseAt')
          })
        }), jsx(Countdown, {
          date: timeToRelease,
          renderer: ({
            days,
            hours,
            minutes,
            seconds
          }) => jsxs(Text, Object.assign({
            color: "outline"
          }, {
            children: [days, "d ", hours, "h ", minutes, "min ", seconds, "s"]
          }))
        })]
      }))]
    }))
  }));
};

export { TimeToReleaseCard };
